import { All, AuthActionTypes } from './auth.actions';
import { AuthState, initialState } from './auth.states';

export function reducer(state = initialState, action: All): AuthState {
  switch (action.type) {
    case AuthActionTypes.LOGIN_SUCCESS: {
      return {
        ...state,
        errorMessage: null,
        responseType: action.payload.responseType,
      };
    }
    case AuthActionTypes.LOGIN_FAILURE: {
      return {
        ...state,
        errorMessage: action.payload.message,
        responseType: action.payload.responseType,
      };
    }
    case AuthActionTypes.LOGOUT_SUCCESS: {
      return {
        ...state,
        errorMessage: null,
        responseType: action.payload.responseType,
      };
    }
    case AuthActionTypes.CHANGE_PASSWORD_SUCCESS: {
      return {
        ...state,
        errorMessage: null,
        responseType: action.payload.message,
      };
    }
    case AuthActionTypes.CHANGE_PASSWORD_FAILURE: {
      return {
        ...state,
        errorMessage: null,
        responseType: action.payload.message,
      };
    }
    case AuthActionTypes.CLEAR_ERROR_MSG: {
      return { ...state, errorMessage: null };
    }
    case AuthActionTypes.SESSION_INVALIDATED: {
      return {
        ...state,
        errorMessage: action.payload.errorMessage,
      };
    }
    default: {
      return state;
    }
  }
}

export function clearState(reducerCallback: (arg0: any, arg1: any) => any) {
  return (
    state: Record<string, any> | undefined,
    action: { type: AuthActionTypes },
  ) => {
    if (
      action.type === AuthActionTypes.LOGOUT_SUCCESS ||
      action.type === AuthActionTypes.SESSION_INVALIDATED
    ) {
      const newState: Record<string, any> = { ...state };
      const featuresToKeep = ['ConfigFeature', 'EncryptionFeature'];
      Object.keys(state || {}).forEach((key) => {
        if (!featuresToKeep.includes(key)) {
          delete newState[key];
        }
      });
      return reducerCallback(newState, action);
    }

    return reducerCallback(state, action);
  };
}
